export default __webpack_public_path__ + "static/media/wafer-bg-bottom.c66d9e55.png";